import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { formatNumber } from "../utils/formatNumber";

function ItemTableModal({ open, onClose, item }) {
  if (!item) return null;

  // รวมข้อมูลสรุป
  const totalWeight = item.details.reduce((sum, d) => sum + d.usedWeight, 0);
  const totalPrice = item.details.reduce((sum, d) => sum + d.totalPrice, 0);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>{item.productName}</DialogTitle>
      <DialogContent dividers>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ประเภทราคา</TableCell>
              <TableCell align="right">น้ำหนักซื้อจริง</TableCell>
              <TableCell align="right">ราคาซื้อ</TableCell>
              <TableCell align="right">ราคารวม</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {item.details.map((detail, idx) => (
              <TableRow key={idx}>
                <TableCell>
                  {(() => {
                    switch (detail.priceSource) {
                      case "po":
                        return `ใบราคาสินค้า PO #${detail?.poInfo?.purchaseOrderId}`;
                      case "so":
                        return `ใบราคาสินค้า SO #${detail?.soInfo?.saleOrderId}`;
                      default:
                        return "ราคาปกติ";
                    }
                  })()}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(detail.usedWeight)}
                </TableCell>
                <TableCell align="right">
                  {(() => {
                    switch (detail.priceSource) {
                      case "po":
                        return formatNumber(detail.poPricePerUnit);
                      case "so":
                        return formatNumber(detail.PricePerUnit);
                      default:
                        return formatNumber(detail.pricePerUnit);
                    }
                  })()}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(detail.totalPrice)}
                </TableCell>
              </TableRow>
            ))}

            {/* แถวสรุป */}
            <TableRow sx={{ backgroundColor: "grey.100" }}>
              <TableCell style={{ fontWeight: "bold" }}>รวม</TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="right">
                {formatNumber(totalWeight)}
              </TableCell>
              <TableCell></TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="right">
                {formatNumber(totalPrice)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </DialogContent>
      {/* <DialogActions>
        <Button onClick={onClose}>ปิด</Button>
      </DialogActions> */}
    </Dialog>
  );
}

export default ItemTableModal;
